<template>
  <div class="payment-method-component">
    <div class="column is-8 is-offset-2">
      <div class="columns">
        <div class="column is-full">
          <p class="is-size-1 has-text-centered has-text-grey-dark dm-sans">
            Qual método de pagamento?
          </p>
        </div>
      </div>
<!--      <div class="columns">-->
<!--        <div class="column is-full">-->
<!--          <div class="buttons is-flex is-justify-content-center is-full">-->
<!--            <button-->
<!--                class="button is-grey is-size-3 has-text-weight-bold mx-6 is-four-fifths"-->
<!--                @click.prevent="generatePaymentByCreditCard"-->
<!--            >-->
<!--              Cartão de Crédito-->
<!--              <font-awesome-icon-->
<!--                  icon="fa-solid fa-credit-card"-->
<!--                  class="ml-4"-->
<!--                  size="1x"-->
<!--              />-->
<!--            </button>-->
<!--            <button-->
<!--              class="button is-grey is-size-3 has-text-weight-bold mx-4 is-four-fifths"-->
<!--              @click.prevent="generatePaymentByBankBillet"-->
<!--              :disabled="AppStoreStore.loading"-->
<!--            >-->
<!--              <span>Boleto</span>-->
<!--              <font-awesome-icon-->
<!--                icon="fa-solid fa-barcode"-->
<!--                class="ml-4"-->
<!--                size="1x"-->
<!--              />-->
<!--            </button>-->
<!--          </div>-->
<!--          <div class="is-flex is-justify-content-center is-full">-->
<!--            <flash-message></flash-message>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->

      <div class="columns">
        <div class="column is-half">
          <div class="buttons is-flex is-justify-content-center is-full">
            <button
                class="button is-grey is-size-3 has-text-weight-bold mx-4 is-fullwidth"
                @click.prevent="setPaymentType('credit_card')"
            >
              <span>
                Cartão
              </span>
            </button>
          </div>
          <div class="buttons is-flex is-justify-content-center is-full">
            <table class="table">
              <tbody>
                <tr>
                  <td class="is-flex is-justify-content-center is-align-content-center has-text-centered">
                    <span><strong>R$ 0,45 / Mensagem Enviada</strong></span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div class="column is-half">
          <div class="buttons is-flex is-justify-content-center is-full">
            <button
                class="button is-grey is-size-3 has-text-weight-bold mx-4 is-fullwidth"
                @click.prevent="setPaymentType('bank_slip')"
            >
              <span>Boleto</span>
            </button>
          </div>
          <div class="buttons is-flex is-justify-content-center is-full">
            <table class="table">
              <tbody>
                <tr>
                  <td class="is-flex is-justify-content-center is-align-content-center has-text-centered">
                    <span><strong>R$ 0,55 / Mensagem Enviada</strong></span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import orderApi from '@/apis/orders'
import { useAppStore } from "@/stores/AppStore";
import { mapStores } from 'pinia'

export default {

  name: 'payment-method',

  props: {
    formData: {
      required: true,
      type: Object
    }
  },

  computed: {
    ...mapStores(useAppStore)
  },

  methods: {
    setPaymentType(type) {
      if (type === 'bank_slip') {
        this.generatePaymentByBankBillet()
        return
      }

      this.generatePaymentByCreditCard()
    },
    async generatePaymentByBankBillet() {
      const customer = this.formData.customer.data
      const orderData = {
        status: 1,
        customer_id: customer.id,
        paymentProfile: {
          payment_method_code: 'bank_slip'
        }
      }

      const order = await orderApi.create(orderData);
      const appStore = useAppStore()
      appStore.orderFormData = this.formData
      appStore.order = order
      appStore.orderType = 'bank_billet'
      await this.$router.push({ path: '/billet', query: {
        vendedor: this.$route.query.vendedor ? this.$route.query.vendedor : 'interno'
      } })
    },
    async generatePaymentByCreditCard() {
      const appStore = useAppStore()
      appStore.orderFormData = this.formData
      // appStore.order = order
      appStore.orderType = 'credit_card'
      await this.$router.push({ path: '/payment', query: {
        vendedor: this.$route.query.vendedor ? this.$route.query.vendedor : 'interno'
      } })
    }
  }

}

</script>
